import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ planzone, resource }) =>
    present(
      repository
        .saveVirtualResourceInPlanzone(planzone, resource)
        .then((resource) => ({ planzone, resource }))
        .catch(() =>
          Promise.reject({
            planzone,
            resource,
          }),
        ),
    );
}

export type { Interactor };

export { createInteractor };
